import { API_ROOT } from 'src/constants';
import Request, { setData, setMethod, setURL } from 'src/services';
import { getNamespaceName } from 'src/services/objects/namespaces';
import { Account } from 'src/types/Account';
import { always, lensPath, set, when } from 'ramda';
import { isNotEmpty } from 'src/utilities/hasValue';
import { compose } from 'recompose';
import { stringifyQueryParam } from 'src/utilities/queryParams';

export const importLoanApps = (id: string, data: any) =>
  Request<Account>(
    setURL(`${API_ROOT}/${getNamespaceName()}/loanapps/${id}/clone`),
    setMethod('PUT'),
    setData(data)
  ).then((response) => response.data);

export const createLoanPrimeV2 = (
  data: any,
  hasEnityAll: boolean = false,
  pullWorkflow: boolean = false,
) => {

  const params = stringifyQueryParam(compose(
    when(always(hasEnityAll), set(lensPath(['entity']), 'all')),
    when(always(pullWorkflow), set(lensPath(['workflow']), 'yes')),
  )({}))
  const queryParam = isNotEmpty(params) ? `?${params}` : '';

  return Request<Account>(
    setURL(`${API_ROOT}/${getNamespaceName()}/loanapps/v2${queryParam}`),
    setMethod('POST'),
    setData(data)
  ).then((response) => response.data)
}


//create a co-applicant (coborrower) to an existing LoanApp.
export const createCoLoanInNamespace = (data: any, id: any, queryString: string = '') =>
  Request<Account>(
    setURL(`${API_ROOT}/${getNamespaceName()}/loanapps/${id}/coapplicant${queryString ? '?' + queryString : ''}`),
    setMethod('POST'),
    setData(data)
  ).then((response) => response.data)

export const createMismoLoan = (data: any, loanData: any) =>
  Request<Account>(
    setURL(`${API_ROOT}/${getNamespaceName()}/loanapps/import/mismo?loan_data=${loanData}`),
    setMethod('POST'),
    setData(data)
  ).then((response) => response.data)
